import React, {Component} from 'react'
import {defineMessages, injectIntl} from 'react-intl'

const messages = defineMessages({
    '0_label': {
        id: 'invoice.recurring.day_of_week.sunday_label',
        defaultMessage: 'Sunday',
    },
    '1_label': {
        id: 'invoice.recurring.day_of_week.monday_label',
        defaultMessage: 'Monday',
    },
    '2_label': {
        id: 'invoice.recurring.day_of_week.tuesday_label',
        defaultMessage: 'Tuesday',
    },
    '3_label': {
        id: 'invoice.recurring.day_of_week.wednesday_label',
        defaultMessage: 'Wednesday',
    },
    '4_label': {
        id: 'invoice.recurring.day_of_week.thursday_label',
        defaultMessage: 'Thursday',
    },
    '5_label': {
        id: 'invoice.recurring.day_of_week.friday_label',
        defaultMessage: 'Friday',
    },
    '6_label': {
        id: 'invoice.recurring.day_of_week.saturday_label',
        defaultMessage: 'Saturday',
    },

})


class DayOfWeekLabel extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            dayOfWeek: this.props.dayOfWeek,
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            dayOfWeek: nextProps.dayOfWeek,
        })
    }

    render() {
        if (this.state.dayOfWeek >= 0 && this.state.dayOfWeek <= 6) {
            return this.props.intl.formatMessage(messages[this.state.dayOfWeek + '_label'])
        }
        return ''
    }

}

export default injectIntl(DayOfWeekLabel)





// WEBPACK FOOTER //
// ./src/invoice/recurring/dayofweeklabel.component.jsx